import attrchange from "lazysizes/plugins/attrchange/ls.attrchange.min.js";
import BGSet from "lazysizes/plugins/bgset/ls.bgset.min.js";
import UnveilHooks from "lazysizes/plugins/unveilhooks/ls.unveilhooks.min.js";
import respimg from "lazysizes/plugins/respimg/ls.respimg.min.js";
import LazySizes from "lazysizes/lazysizes.min.js";
import "floatthead";

$(function() {
    var $window = $(window);
    var $document = $(document);
    var $html = $("html");
    var $body = $("body");
    var $heroFollow = $(".hero-follow");
    var $heroOverlay = $(".hero-overlay");
    var $servicesSection = $("section.services");
    var $headerPrimary = $("header.primary");
    var $mobileNavOpen = $("button.-mobile-trigger");
    var $mobileNavClose = $("button.-mobile-close");
    var $mobileNavigation = $("nav.mobile-navigation");
    var $mobilePrimarynav = $(".m-nav-panel.-primary");
    var $mobileNavLink = $(".hasSub");
    var $mobileSubClose = $(".nav-link.-back");
    var $twoColumnBrand = $(".two-column-brand .branding");
    var $stats = $(".stats");
    var $HBtextarea = $("textarea.hs-input");
    var $jsFormModal = $(".js-formModal");
    var $contactModal = $(".contact-modal");
    var $jsformModalClose = $(".js-formModalClose");
    var jsformModalContainer = document.querySelector(".js-formModalContainer");
    var newScript;

    /* Responsive Tester */
    $window.resize(function() {
        $.data(
            this,
            "resizeTimer",
            setTimeout(function() {
                $("#responsive-tester").html(
                    $(window).width() + " by " + $(window).height()
                );
            }, 400)
        );
    });
    $window.resize();

    /* Sticky Nav Styling Hooks */
    $window.scroll(function() {
        if ($window.scrollTop() > 10) {
            $body.addClass("scrolled");
        } else {
            $body.removeClass("scrolled");
        }
    });
    $window.scroll();

    /* Hompage Background-Switcher */
    if ($heroFollow.length) {
        var stopPoint = $servicesSection.offset().top;

        var backgroundSwitch = function() {
            if ($window.scrollTop() + $window.height() > stopPoint) {
                $heroFollow.addClass("stick");
                $heroOverlay.addClass("stick");
            } else {
                $heroFollow.removeClass("stick");
                $heroOverlay.removeClass("stick");
            }
        };
        backgroundSwitch();

        $window.scroll(function() {
            stopPoint = $servicesSection.offset().top - 30;
            backgroundSwitch();
        });
    }

    /* Hero Overlay Fades */
    if ($heroOverlay.length) {
        var scrollTop = 0;
        var finalOpacity = 0;
        var fadePoint =
            scrollTop / ($servicesSection.offset().top - $window.height());
        var overlayFade = function() {
            if (
                scrollTop < $servicesSection.offset().top - $window.height() &&
                $window.width() > 770
            ) {
                $heroOverlay.css("opacity", fadePoint);
            } else {
                $heroOverlay.css("opacity", 1);
            }
        };

        overlayFade();

        $document.scroll(function() {
            scrollTop = $window.scrollTop();
            fadePoint =
                scrollTop / ($servicesSection.offset().top - $window.height());
            overlayFade();
        });
        $window.resize(function() {
            if ($window.width() < 770) {
                $heroOverlay.css("opacity", 1);
            } else {
                overlayFade();
            }
        });
    }

    /* Testimonial fade-in */
    $window.scroll(function() {
        scrollTop = $window.scrollTop();

        if (scrollTop > $(".hero .testimonial.--large").height()) {
            $(".hero .testimonial.--large").addClass("reveal");
        } else {
            $(".hero .testimonial.--large").removeClass("reveal");
        }
    });

    /* Mobile Navigation */
    $mobileNavOpen.on("click", function() {
        $mobileNavigation.addClass("opened");
        $html.css("overflow", "hidden");
        setTimeout(function() {
            $mobileNavigation.addClass("revealed");
        }, 50);
    });

    $mobileNavClose.on("click", function() {
        $mobileNavigation.removeClass("revealed");
        $html.css("overflow", "visible");
        $html.css("overflow-x", "hidden");
        setTimeout(function() {
            $mobileNavigation.removeClass("opened");
            $(".m-nav-panel.opened").removeClass("opened");
            $(".m-nav-panel.closed").removeClass("closed");
            $mobileSubClose.css("display", "none");
        }, 100);
    });

    // Mobile Subnavs
    $mobileNavLink.on("click", function() {
        var thisData = $(this).attr("data-menu");
        $('.m-nav-panel.-sub[data-menu="' + thisData + '"]').addClass("opened");
        $mobilePrimarynav.addClass("closed");
        $mobileSubClose.css("display", "block");
    });

    $mobileSubClose.on("click", function() {
        $(".m-nav-panel.opened").removeClass("opened");
        $(".m-nav-panel.closed").removeClass("closed");
        $mobileSubClose.css("display", "none");
    });

    /* Two Column Brand - Short Class Toggle */
    if ($twoColumnBrand.length) {
        $document.ready(function() {
            $twoColumnBrand.each(function() {
                let thisHeight = $(this).outerHeight();

                if (thisHeight < 900) {
                    $(this).addClass("--short");
                }
            });
        });
    }

    /* Hubspot text area line height overide */
    if ($HBtextarea.length) {
        $HBtextarea.attr("rows", "5");
    }

    if ($("table").length) {
        $("table").on("floatThead", function(e, isFloated, $floatContainer) {
            if (isFloated) {
                $floatContainer.addClass("floated"); // the div containing the table containing the thead
                $(this).addClass("floated"); // $table
            } else {
                $floatContainer.removeClass("floated");
                $(this).removeClass("floated");
            }
        });

        $("table").floatThead({
            top: 68,
            floatContainerClass: "sticky-head",
            zIndex: 998
        });
    }
    /* hubspot forms in modal*/
    $jsFormModal.click(function(e) {
        e.preventDefault();
        let formEmbed = $(this).attr("data-embed");
        let finalScriptContents = `
            hbspt.forms.create({
                portalId: "3412255",
                formId: "${formEmbed}"
            });
        `;
        newScript = document.createElement("script");

        newScript.innerHTML = finalScriptContents;
        jsformModalContainer.appendChild(newScript);
        $html.css("overflow", "hidden");
        $contactModal.fadeIn(250);
    });

    $jsformModalClose.click(function() {
        $contactModal.fadeOut(250);
        jsformModalContainer.innerHTML = "";
        $html.css("overflow", "visible");
        $html.css("overflow-x", "hidden");
        newScript.remove();
    });

    /* Search Bar */
    $('.search_link').click(function(e) {
        e.preventDefault();
        $('.nav-search').toggleClass('close');
    })
});
